import { getPageType } from './getPageType';
export const getActiveBanners = (banners, currentPageType, currentTime = new Date()) => {
    // Safely handle SSR context where window might not exist
    const pageType = currentPageType !== null && currentPageType !== void 0 ? currentPageType : (typeof window !== 'undefined' ? getPageType(window.location.href) : undefined);
    // If we can't determine page type, return empty array
    if (!pageType) {
        return [];
    }
    // Defensive check for banners array
    if (!Array.isArray(banners) || banners.length === 0) {
        return [];
    }
    // Filter banners that meet all criteria
    const activeBanners = banners.filter((banner) => {
        var _a, _b;
        // Skip invalid banners
        if (!banner)
            return false;
        // If targeting is empty or pageType doesn't exist, show on all pages
        if (!banner.targeting || (Array.isArray(banner.targeting) && banner.targeting.length === 0)) {
            return true; // Show on all pages
        }
        // Check if banner is targeted for current page type
        if (!((_b = (_a = banner.targeting) === null || _a === void 0 ? void 0 : _a.pageType) === null || _b === void 0 ? void 0 : _b.includes(pageType))) {
            return false;
        }
        // Check if banner is within its programmed date range
        return (Array.isArray(banner.programmation) &&
            banner.programmation.some(({ start, end }) => {
                // Validate start and end arrays
                if (!Array.isArray(start) || start.length < 2 || !Array.isArray(end) || end.length < 2) {
                    return false;
                }
                const [startDate, startTime] = start;
                const [endDate, endTime] = end;
                try {
                    const startDateTime = new Date(`${startDate}T${startTime}`);
                    const endDateTime = new Date(`${endDate}T${endTime}`);
                    // Check if dates are valid and current time is within range
                    return (!isNaN(startDateTime.getTime()) && !isNaN(endDateTime.getTime()) && currentTime >= startDateTime && currentTime <= endDateTime);
                }
                catch (e) {
                    return false;
                }
            }));
    });
    // Sort by priority (lower number = higher priority)
    return activeBanners.sort((a, b) => a.priority - b.priority);
};
